import styled from '@emotion/styled';
import { Slider } from '@mui/material';

export const StyledSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-thumb': {
    width: 25,
    height: 25,
    backgroundColor: 'white',
    border: '2px solid skyBlue',
  },
  '& .MuiSlider-valueLabel': {
    display: 'none',
  },
  '& .MuiSlider-mark': {
    display: 'none',
  },
}));

export const StyledSliderOverall = styled(Slider)(({ theme }) => ({
  color: 'pink',
  '& .MuiSlider-thumb': {
    display: 'none',
  },
  '& .MuiSlider-valueLabel': {
    display: 'none',
  },
  '& .MuiSlider-mark': {
    display: 'none',
  },
  '&.Mui-disabled .MuiSlider-thumb': {
    backgroundColor: 'white',
    border: '2px solid pink',
  },
  '&.Mui-disabled .MuiSlider-track': {
    backgroundColor: 'pink',
  },
  '&.Mui-disabled .MuiSlider-rail': {
    backgroundColor: 'pink',
  },
}));
